module.exports = __webpack_public_path__ + "assets/img/logo-3.47645c8a.png";